import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { FinanceDealsSelectorFragment } from 'generated/resources/graphql'

export function mapToFinanceDealSelectorFragment(
  selected: EntitySelectEntity,
  available: FinanceDealsSelectorFragment[]
): FinanceDealsSelectorFragment {
  const entity = available.find((a) => a.id === selected.id)

  // This should never happen
  if (!entity) {
    throw new Error('Deal not found')
  }

  return {
    __typename: 'FinanceDeal',
    id: String(entity.id),
    name: entity.name,
    client: entity.client,
    currency: entity.currency,
    estimatedAmountCents: entity.estimatedAmountCents,
    expectedCloseDate: entity.expectedCloseDate,
  }
}

export function mapToEntitySelectEntity(
  financeDeals: FinanceDealsSelectorFragment[]
): EntitySelectEntity[] {
  return financeDeals.map((element) => {
    return {
      id: element.id,
      name: element.name,
      searchKey: [element.name],
    }
  })
}
